<template>
  <div v-if="!loading">
    <h2>Barfhero imports</h2>

    <span>Reorder date: {{ formatDatetime(reorder_date) }}</span>
    <div class="flex flex-col mb-4">
        <table class="table-auto text-sm bg-white w-full">
            <thead class="text-left">
              <tr class="bg-primary-100">
                <th class="px-4 py-3 rounded-l-lg text-xs font-semibold text-primary-700 uppercase tracking-wide">Nombre</th>
                <th class="px-4 py-3 text-xs font-semibold text-primary-700 uppercase tracking-wide">Email</th>
                <th class="px-4 py-3 rounded-r-lg text-xs font-semibold text-primary-700 uppercase tracking-wide">Mascotas</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="user in next_users" :key="user.email" class="table-row">
                <td class="table-cell">{{ user.name }} {{ user.last_name }}</td>
                <td class="table-cell">{{ user.email }}</td>
                <td class="table-cell">
                    <ul style="list-style: circle;">
                        <li v-for="pet in user.pets" :key="pet.name">{{ pet.name }}</li>
                    </ul>
                </td>
              </tr>
            </tbody>
        </table>
    </div>
  </div>

  <div v-else class="flex w-full h-full items-center">
    <loader-icon class="h-10 w-10 text-primary-500 mx-auto"></loader-icon>
  </div>
</template>

<script>
import OptionsMenu from "@/components/ui/OptionsMenu";
import api from "@/api";
import { formatDatetime } from "@/utils/dateFormatter";
export default {
  name: "BarfheroImport",

  components: {
    OptionsMenu,
  },

  data() {
    return {
      next_users: null,
      loading: true,
      reorder_date: 0,
    };
  },

  created() {
    this.$store.commit("setSelectedTab", "barfheroImport");

    this.loadBarfheroImports();
  },

  methods: {
    formatDatetime,

    async loadBarfheroImports() {
      this.loading = true;

      try {
        const response = await api.barfheroImport.getNextUsers();
        this.next_users = response.next_users;
        this.reorder_date = response.reorder_date;
      console.log('response', response);
      } catch (error) {
        console.log('error', error);
        this.$store.dispatch("errorSnack", error?.response?.data?.message);
      }

      this.loading = false;
    },
  },
};
</script>